import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {ApiService} from './api.service';
import {CrudUtilities} from '../util/crud-utilities';
import {map} from 'rxjs/operators';
import {RealEstateAgentsModel} from '../models/real-estate-agent-items.model';
import {RealEstateAgentModel} from '../models/realEstateAgentModel';

@Injectable({
  providedIn: 'root'
})
export class RealEstateAgentService {


  public realEstateAgentItemsSubject = new BehaviorSubject<RealEstateAgentsModel>(new RealEstateAgentsModel());
  public realEstateAgentItems = this.realEstateAgentItemsSubject.asObservable();

  public selectedRealEstateAgentItemSubject = new BehaviorSubject<RealEstateAgentModel>(new RealEstateAgentModel());
  public selectedRealEstateAgentItem = this.selectedRealEstateAgentItemSubject.asObservable();


  constructor(private apiService: ApiService, public crudUtils: CrudUtilities) {

  }

  setRealEstateAgentItems(realEstateAgentItems: RealEstateAgentsModel) {
    this.realEstateAgentItemsSubject.next(realEstateAgentItems);
  }

  createRealEstateAgentItem(realEstateAgent: RealEstateAgentModel) {
    return this.apiService.post('realEstateAgents.json', realEstateAgent).subscribe((response) => {

      if (response.name) {
        realEstateAgent.id = response.name;
        this.selectedRealEstateAgentItemSubject.next({...realEstateAgent});
        this.crudUtils.addNewItemToList(this.realEstateAgentItemsSubject, realEstateAgent);
      }
    });
  }

  editRealEstateAgentItem(realEstateAgent: RealEstateAgentModel) {
    return this.apiService
      .patch(`realEstateAgents/${realEstateAgent.id}.json`, realEstateAgent).subscribe((response) => {
        this.selectedRealEstateAgentItemSubject.next({...response});
        this.crudUtils.editListItem(this.realEstateAgentItemsSubject, response);
      });
  }

  deleteRealEstateAgentItem(realEstateAgent, dialogRef) {
    return this.apiService.delete(`realEstateAgents/${realEstateAgent.id}.json`).subscribe(() => {
      this.crudUtils.deleteListItem(this.realEstateAgentItemsSubject, realEstateAgent);
      dialogRef.close();

    });
  }

  getRealEstateAgentItems() {
    return this.apiService.get('realEstateAgents.json').pipe(map((response) => {

      const list = [];
      // tslint:disable-next-line:forin
      for (const key in response) {
        response[key].id = key;
        list.push(response[key]);
      }
      return list;
    }));
  }

}
